import { SkiptraceEvents } from 'features/Skiptrace/infra/events/Skiptrace.events'
import { skiptraceStore } from 'features/Skiptrace/infra/react/Skiptrace.state.store'
import { LegacyBillingEvents } from 'presentation/screens/Billing/Billing.events'

// When skiptrace is performed, re-probe the wallet-backed single skiptrace
// attempt so the UI reflects the current individual entitlement state.
SkiptraceEvents.performSkiptraceDone.subscribe(() => {
  const state = skiptraceStore.getState()
  const resultState = state.entities.resultState

  // Only refresh if we have a successful result with subject info containing an address
  if (resultState.status === 'success' && resultState.result?.subject?.address) {
    void state.actions.refreshSkiptraceFundsInfo.execute({
      leadId: resultState.params.leadId,
      address: resultState.result.subject.address,
    })
  }
})

// When funds are added, re-probe the current single skiptrace attempt state.
LegacyBillingEvents.addFundsDone.subscribe(() => {
  const state = skiptraceStore.getState()
  const resultState = state.entities.resultState

  // Only refresh if we have a successful result with subject info containing an address
  if (resultState.status === 'success' && resultState.result?.subject?.address) {
    void state.actions.refreshSkiptraceFundsInfo.execute({
      leadId: resultState.params.leadId,
      address: resultState.result.subject.address,
    })
  }
})
